export abstract class Command<TAction> {

  abstract do(arg: TAction): void;

  abstract undo(): void;

  dispose() {
  }
}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/commands/Command.ts